import { css } from '@emotion/react';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import GetHelpTextButton from 'src/components/creditApplication/GetHelpTextButton';

const UnknownErrorPage = () => {
  return (
    <CreditApplicationPageLayout
      showLogo={false}
      icon='AlertFilled24'
      title='Looks like something is&nbsp;wrong'
      subtitle={
        'Our team will get back to you as soon as possible. Response times may be delayed during peak and off-hours.'
      }
    >
      <div css={root}>
        <GetHelpTextButton />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;

export default UnknownErrorPage;
